import * as THREE from 'three';

export const BALL_RADIUS = 0.11;

/** Classic black-pentagon ball from a subdivided icosahedron with per-face colours. */
export function buildBall(): THREE.Mesh {
  const g = new THREE.IcosahedronGeometry(BALL_RADIUS, 5);
  const phi = (1 + Math.sqrt(5)) / 2;
  const raw = [[-1, phi, 0], [1, phi, 0], [-1, -phi, 0], [1, -phi, 0], [0, -1, phi], [0, 1, phi], [0, -1, -phi], [0, 1, -phi], [phi, 0, -1], [phi, 0, 1], [-phi, 0, -1], [-phi, 0, 1]];
  const centres = raw.map(([x, y, z]) => new THREE.Vector3(x!, y!, z!).normalize());
  const pos = g.attributes.position!;
  const colors = new Float32Array(pos.count * 3);
  const a = new THREE.Vector3(), b = new THREE.Vector3(), c = new THREE.Vector3();
  const white = new THREE.Color('#f4f4f2'), black = new THREE.Color('#121418'), seam = new THREE.Color('#c9c9c6');
  const cosPent = Math.cos(THREE.MathUtils.degToRad(17));
  const cosSeam = Math.cos(THREE.MathUtils.degToRad(19.5));
  for (let i = 0; i < pos.count; i += 3) {
    a.fromBufferAttribute(pos, i); b.fromBufferAttribute(pos, i + 1); c.fromBufferAttribute(pos, i + 2);
    const m = a.add(b).add(c).normalize();
    let best = -1;
    for (const ce of centres) best = Math.max(best, m.dot(ce));
    const col = best > cosPent ? black : best > cosSeam ? seam : white;
    for (let k = 0; k < 3; k++) { colors[(i + k) * 3] = col.r; colors[(i + k) * 3 + 1] = col.g; colors[(i + k) * 3 + 2] = col.b; }
  }
  g.setAttribute('color', new THREE.BufferAttribute(colors, 3));
  g.deleteAttribute('uv');
  const mat = new THREE.MeshStandardMaterial({ vertexColors: true, roughness: 0.38, metalness: 0 });
  const mesh = new THREE.Mesh(g, mat);
  mesh.name = 'ball';
  return mesh;
}
